module.exports = __webpack_public_path__ + "img/ubic-white.8bf422f1.svg";